// AppRoutes.js
import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { Routes } from "../routes";


// Rotas publicas e ConnectApp
import ConnectApp from "./ConnectApp";
import HomePage from "./HomePage";

export default function AppRoutes() {
    return (
        <Switch>
            {/* Frontend público */}
            <Route exact path={Routes.Presentation.path} component={HomePage} />

            {/* Tudo que começa por /connect */}
            <Route path="/connect" component={ConnectApp} />
        </Switch>
    );
}
